import React, { useEffect, useState, useRef } from "react";
import Button from "@mui/material/Button";
import slEmblem from "../../images/logo_w_en.svg";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import axios from "axios";

const LoginPage = () => {
  const [showSnackBar, setShowSnackBar] = React.useState(false);

  const [email, setUsername] = useState("");

  const [playVideo, setPlayVideo] = React.useState(false);
  const [introVideoUrl, setIntroVideo] = useState("");
  const navigate = useNavigate();
  const bgNarration = useRef(null);

  useEffect(() => {
    if (introVideoUrl) {
      setPlayVideo(true);
    }
  }, [introVideoUrl]);

  const videoReady = () => {
    setPlayVideo(true);
  };

  useEffect(() => {
    // 🔥 kill background audio
    if (window.__BG_AUDIO__) {
      try {
        window.__BG_AUDIO__.pause();
        window.__BG_AUDIO__.currentTime = 0;
      } catch (e) { }
      window.__BG_AUDIO__ = null;
    }

    // 🔥 kill narration audio
    if (window.__NARRATION_AUDIO__) {
      try {
        window.__NARRATION_AUDIO__.pause();
        window.__NARRATION_AUDIO__.currentTime = 0;
      } catch (e) { }
      window.__NARRATION_AUDIO__ = null;
    }

    // 🔥 also kill any DOM audio just in case
    document.querySelectorAll("audio").forEach((a) => {
      try {
        a.pause();
        a.currentTime = 0;
      } catch (e) { }
    });
  }, []);

  useEffect(() => {
    const unlockAudio = () => {
      startBackgroundNarrationAudio();

      // Remove ALL listeners after first trigger
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
      window.removeEventListener("keydown", unlockAudio);
      window.removeEventListener("pointerdown", unlockAudio);
    };

    window.addEventListener("click", unlockAudio);
    window.addEventListener("touchstart", unlockAudio);
    window.addEventListener("keydown", unlockAudio);
    window.addEventListener("pointerdown", unlockAudio);

    return () => {
      window.removeEventListener("click", unlockAudio);
      window.removeEventListener("touchstart", unlockAudio);
      window.removeEventListener("keydown", unlockAudio);
      window.removeEventListener("pointerdown", unlockAudio);
    };
  }, []);

  useEffect(() => {
    getColors();
    getVideos();
  }, []);

  const getColors = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Colors/getColors"
      );
      document.documentElement.style.setProperty(
        "--primary-color",
        response.data.primaryColor
      );
      document.documentElement.style.setProperty(
        "--secondary-color",
        response.data.secondaryColor
      );
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const getVideos = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Videos/getVideos"
      );
      setIntroVideo(response.data.introVideo);
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const onLoginClick = async (event) => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777458376/LOGIN_nmximm.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    event.preventDefault();
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "authentication/getTourUser/" + email
      );
      if (response.status == 404) {
        handleSnackBarOpen();
      }
      if (response.status == 200) {
        let loginUser = response.data[0];
        if (loginUser) {
          try {
            const responseA = await axios.put(
              process.env.REACT_APP_API + "authentication/updateLoginDate/",
              loginUser
            );
            if (responseA.status == 404) {
              handleSnackBarOpen();
            }
            if (responseA.status == 200) {
              sessionStorage.setItem("tourUser", JSON.stringify(loginUser));
              stopAllAudio();
              navigate("/parliament-tour");
            }
          } catch (error) {
            handleSnackBarOpen();
          }
        } else {
          handleSnackBarOpen();
        }
      }
    } catch (error) {
      handleSnackBarOpen();
    }
  };

  const onStartTourClick = async (event) => {
    event.preventDefault();
    stopAllAudio();
    setTimeout(() => {
      navigate("/parliament-tour");
    }, 1000);
  };

  const handleSnackBarOpen = () => {
    setShowSnackBar(true);
  };

  const handleSnackBarClose = () => {
    setShowSnackBar(false);
  };

  const startBackgroundNarrationAudio = () => {
    if (!bgNarration.current) {
      const audio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777370841/1_Intro_Musiconly_Master_seqyym.mp3");
      window.__BG_AUDIO__ = audio;
      audio.loop = true;
      audio.volume = 0.5;
      bgNarration.current = audio;
    }

    bgNarration.current.play().catch((err) => {
      console.log("BG AUDIO BLOCKED:", err);
    });
  };

  const stopAllAudio = () => {
    if (bgNarration.current) {
      bgNarration.current.pause();
      bgNarration.current.currentTime = 0;
    }
  };

  return (
    <div className="video-page-container">
      {!playVideo && <div className="loading-black-bg"></div>}
      <Snackbar
        open={showSnackBar}
        autoHideDuration={6000}
        onClose={handleSnackBarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackBarClose}
          severity="warning"
          sx={{ width: "100%" }}
        >
          Unauthorized email!!! Cannot proceed!!!
        </Alert>
      </Snackbar>
      <div className="video-bg">
        <ReactPlayer
          className="video-container"
          url={introVideoUrl}
          loop={true}
          playing={playVideo}
          muted={true}
          controls={false}
          playsinline={true}
        />
        <div className="landing-container">
          <div className="center-container">
            <div className="login-center-container">
              <div className="flex-column-container">
                <img className="sl-emblem" src={slEmblem} alt="" />
                <span className="landing-heading">VIRTUAL TOUR OF</span>
                <span className="landing-heading">PARLIAMENT OF SRI LANKA</span>
              </div>
              <div className="flex-column-container login-div">
                {/* <Form className="d-flex flex-column">
                  <span className="language-select-text">
                    Please enter an authorized email to enter
                  </span>
                  <Form.Group className="d-flex flex-column">
                    <Form.Control
                      className="login-input-control"
                      type="text"
                      placeholder="Enter authorized email"
                      value={email}
                      onChange={(e) => setUsername(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          onLoginClick(e);
                        }
                      }}
                    />
                  </Form.Group>
                  <Button
                    type="button"
                    className="login-btn"
                    variant="contained"
                    onClick={onLoginClick}
                  >
                    Login
                  </Button>
                </Form> */}
                <Button
                  type="button"
                  className="login-btn mt-20"
                  variant="contained"
                  onClick={onStartTourClick}
                >
                  Start Tour
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
